module.exports = __webpack_public_path__ + "static/media/statistics.95bc7d8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/userguide/statistics.png
// module id = 311
// module chunks = 0